module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-4.2c7ef2bc.png";